import React, { useEffect, useState, useMemo } from "react";
import { motion } from "framer-motion";

const PALETTE = {
  default: { main: "#A9A9A9", accent: "#575757" },
  correct: { main: "#40BF6A", accent: "#2F7A52" },
  wrong: { main: "#E24D4D", accent: "#7A2A2A" },
  selected: { main: "#F0B90B", accent: "#8A6E00" },
  disabled: { main: "#6B7280", accent: "#4B5563" },
};

export default function AnswerContainerComponent({
  state = "default",
  text = "",
  duration = 0.45,
}) {
  const [svgState, setSvgState] = useState(state);
  useEffect(() => setSvgState(state), [state]);

  const palette = useMemo(
    () => PALETTE[svgState] ?? PALETTE.default,
    [svgState]
  );

  const transition = useMemo(
    () => ({ duration, ease: "easeInOut" }),
    [duration]
  );

  return (
    <div className="w-full min-w-[544px] min-h-[119px] relative flex items-center justify-center">
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <span
          dir="rtl"
          className="text-white text-[22px] font-normal px-6 text-center select-none"
        >
          {text}
        </span>
      </div>

      {/* SVG */}
      <div className="w-full h-full relative">
        <svg
          viewBox="0 0 545 119"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-auto block"
          aria-hidden="true"
          focusable="false"
        >
          {/* Main body — animates to palette.main */}
          <motion.path
            d="M31.3127 108.838H526.425L538.314 101.601V10.784L526.425 3.54676H17.7161L5.82744 10.784V93.3239L31.3127 108.838ZM361.427 112.385L346.225 119H197.917L182.714 112.385H28.8981L0 94.7931V9.31489L15.3016 -0.000488281H528.837L544.139 9.31489V103.07L528.837 112.385H527.63H361.427Z"
            initial={{ fill: PALETTE.default.main }}
            animate={{ fill: palette.main }}
            transition={transition}
          />

          {/* Accents — all animate to palette.accent */}
          <motion.path
            d="M39.0165 97.5113H516.677L519.708 95.6663V24.4307H458.881L436.91 14.8732H27.4634L24.4327 16.7182V88.6317L39.0165 97.5113ZM517.277 99.2849H37.8092L21.5176 89.3656V15.9843L26.2561 13.0996H437.829L459.797 22.6571H522.617V96.4002L517.879 99.2849H517.277Z"
            initial={{ fill: PALETTE.default.accent }}
            animate={{ fill: palette.accent }}
            transition={transition}
          />
          <motion.path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M522.62 13.0996V19.7864H493.026L477.658 13.0996H522.62Z"
            initial={{ fill: PALETTE.default.accent }}
            animate={{ fill: palette.accent }}
            transition={transition}
          />
          <motion.path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M469.694 13.0996H461.727L477.097 19.7864H485.064L469.694 13.0996Z"
            initial={{ fill: PALETTE.default.accent }}
            animate={{ fill: palette.accent }}
            transition={transition}
          />
          <motion.path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M453.762 13.0996H445.795L461.165 19.7864H469.13L453.762 13.0996Z"
            initial={{ fill: PALETTE.default.accent }}
            animate={{ fill: palette.accent }}
            transition={transition}
          />
          <motion.path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 100.498V112.385H19.5257L0 100.498Z"
            initial={{ fill: PALETTE.default.accent }}
            animate={{ fill: palette.accent }}
            transition={transition}
          />
        </svg>
      </div>
    </div>
  );
}
